<div class="eui-alert__content-wrapper">
    <div role="alert">
        <ng-content></ng-content>
    </div>
    <div *ngIf="isCloseable" role="button" aria-label="Close Icon Button" (click)="onCloseClick($event)" class="eui-alert__close"></div>
</div>
